/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/example/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(8);
	var Video = __webpack_require__(6);
	var _package = __webpack_require__(7);
	
	var App = React.createClass({
	  displayName: 'App',
	
	  handlePlay: function handlePlay(player) {
	    console.log('onPlay', player);
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'app' },
	      React.createElement(
	        'h1',
	        null,
	        _package.name
	      ),
	      React.createElement(
	        'h2',
	        null,
	        _package.description
	      ),
	      React.createElement(Video, {
	        src: 'http://www.w3schools.com/html/mov_bbb.mp4',
	        type: 'video/mp4',
	        onPlay: this.handlePlay
	      })
	    );
	  }
	});
	
	ReactDOM.render(React.createElement(App, null), document.getElementById('app'));

/***/ },
/* 1 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function blacklist(src) {
	  var copy = {},
	      filter = arguments[1];
	
	  if (typeof filter === 'string') {
	    filter = {};
	    for (var i = 1; i < arguments.length; i++) {
	      filter[arguments[i]] = true;
	    }
	  }
	
	  for (var key in src) {
	    // blacklist?
	    if (filter[key]) continue;
	
	    copy[key] = src[key];
	  }
	
	  return copy;
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }
	
	/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = ({}).hasOwnProperty;
	
		function classNames() {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes += ' ' + arg;
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(1)) === 'object' && __webpack_require__(1)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ },
/* 5 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(5);
	var cx = __webpack_require__(4);
	var blacklist = __webpack_require__(3);
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	  displayName: 'VideoJS',
	
	  componentDidMount: function componentDidMount() {
	    var self = this;
	    var player = videojs(this.refs.video, this.props.options).ready(function () {
	      self.player = this;
	      self.player.on('play', self.handlePlay);
	    });
	    if (this.props.onPlayerInit) this.props.onPlayerInit(player);
	  },
	
	  handlePlay: function handlePlay() {
	    if (this.props.onPlay) this.props.onPlay(this.player);
	  },
	
	  render: function render() {
	    var props = blacklist(this.props, 'children', 'className', 'src', 'type', 'onPlay');
	    props.className = cx(this.props.className, 'videojs', 'video-js vjs-default-skin');
	
	    assign(props, {
	      ref: 'video',
	      controls: true
	    });
	
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'video',
	        props,
	        React.createElement('source', { src: this.props.src, type: this.props.type })
	      )
	    );
	  }
	});

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = {
		"name": "react-videojs",
		"version": "0.0.1",
		"description": "react videojs wrapper",
		"main": "index.js",
		"scripts": {
			"start": "webpack-dev-server -c --port=7788",
			"build": "babel src --out-dir dist && webpack -p",
			"deploy": "npm run build && github-pages-deploy",
			"test": "echo \"Error: no test specified\" && exit 1"
		},
		"github-pages-deploy": {
			"src": "example"
		},
		"repository": {
			"type": "git",
			"url": "git+https://github.com/esportsguy/react-videojs.git"
		},
		"peerDependencies": {
			"react": "^0.14.0",
			"react-dom": "^0.14.0"
		},
		"keywords": [
			"react-component",
			"videojs",
			"video",
			"react"
		],
		"author": "Wang Zuo",
		"license": "ISC",
		"bugs": {
			"url": "https://github.com/esportsguy/react-videojs/issues"
		},
		"homepage": "https://github.com/esportsguy/react-videojs#readme",
		"dependencies": {
			"blacklist": "^1.1.2",
			"classnames": "^2.2.0",
			"object-assign": "^4.0.1"
		},
		"devDependencies": {
			"babel-core": "^6.2.1",
			"babel-loader": "^6.2.0",
			"babel-preset-es2015": "^6.1.18",
			"babel-preset-react": "^6.1.18",
			"github-pages-deploy": "0.0.3",
			"json-loader": "^0.5.3",
			"webpack": "^1.12.8"
		}
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = ReactDOM;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/